import React, { useState, useEffect, useRef } from "react";
import TotalizaResultados from "./TotalizaResultados";
import GraficoBarResultados from "./GraficoBarResultados";
import ExpDataExcel from "./ExpDataExcel";
import { getgraphicspromespera, getparamsgraphics } from "../../../services/graphics";
import { ErrorContext } from '../../../utils/context/error';
import IconM from '../../dashboard/menu/icons/Icon';
import FilterModal from "./filtermodal";

const InformePromEspera = () => {
  const [resultados, setResultados] = useState([]);
  const [detalles, setDetalles] = useState([]);
  const [AreaFId, setAreaFId] = useState(0);
  const [showM, setShowM] = useState(false); 
  const { setShowToast, setOpciones } = ErrorContext();
  
  let NombreArea = useRef("");
  let NombreServicio = useRef("");
  let FechaDesde = useRef("");
  let FechaHasta = useRef("");
  
  //-----------------------------------------------------
  useEffect(() => 
    {
      //setRuta("Informes / Informe Promedio de Visita");
      const fillInicioGrafica = async() => 
        {
           const response = await getparamsgraphics();
           if (response) 
            {
              if (response.status === 200) 
                {
                   setAreaFId(response.data.area[0].AreaId);
                   NombreArea.current = response.data.area[0].NombreArea; 
                }
              else
               {
                  const Mensaje = response.message;
                  const opc = { type: "Danger", message: Mensaje, active: true };
                  setOpciones(opc);
                  setShowToast(true);
               }
            }
        }
      fillInicioGrafica();
    }, []);
    
    //---------------------------------------------------
    const realizarConsulta = async (AreaId, servicioId, fechadesde, fechahasta) => 
      {
         FechaDesde.current= fechadesde;
         FechaHasta.current = fechahasta;
  
         const response = await getgraphicspromespera(AreaId, servicioId, formatFecha(fechadesde), formatFecha(fechahasta));
         if (response) 
           {
               if (response.status === 200) 
                {
                   setResultados(response.data.data);
                   NombreArea.current = response.data.area[0].NombreArea; 
                   if (response.data.servicio.length >0)
                     NombreServicio.current = response.data?.servicio[0]?.NombreServ;
                   setDetalles(response.data.detalle);
                }
               else 
                {
                  const Mensaje = response.message;
                  const opc = { type: "Danger", message: Mensaje, active: true };
                  setOpciones(opc);
                  setShowToast(true);
                }
            }
      };

    //---------------------------------------------------
    const formatFecha = (date) => 
      {
         const formattedDate = new Date(date);
         const year = formattedDate.getUTCFullYear();
         const month = String(formattedDate.getUTCMonth() + 1).padStart(2, "0");
         const day = String(formattedDate.getUTCDate()).padStart(2, "0");
         return `${year}${month}${day}`;
      };
  
    //---------------------------------------------------
    const handleFiltrar = () =>
      {
         setShowM(true);
      }
    return (
    <>
    <div className="">
         <div className="paneltitle">
           <label className="text-[1.0rem] font-light text-gray-400 leading-none">Informes/Promedio Espera</label>
         </div>
         <div className="panelmenu">
            <button className="btnmenu" onClick={() => handleFiltrar()} >
              <IconM svg="filter" className="iconmenu" title="newfile" />
              <span>Filtrar</span>
            </button>

            <button className="btnmenu" id="Eliminar" onClick={() => ExpDataExcel({ detalles })}>
              <IconM svg="fileexcel" className="iconmenu" title="delfile" />
              <span>Exportar</span>
            </button>
         </div>
         <div className="flex w-full md:m-4 text-[1.0rem] font-light text-gray-400 leading-none text-center items-center justify-center">Informe Promedio de Espera</div>
         <div className='flex flex-col md:flex-row w-full h-full mt-4'> 
           <div className='flex md:flex-1 w-[100%] h-full items-center justify-center md:px-4'>
              <TotalizaResultados
                resultados={resultados}
                NombreArea={NombreArea.current}
                NombreServ={NombreServicio.current}
                FechaDesde={FechaDesde.current}
                FechaHasta={FechaHasta.current}
              />
           </div>
           <div className='flex md:flex-1 w-[100%] h-full items-center justify-center md:px-4'>
              <GraficoBarResultados resultados={resultados} />
           </div>
         </div>
      </div>
      {showM && (  
        <FilterModal
          show={showM}
          setShowM={setShowM}
          AreaI={AreaFId}
          realizarConsulta={realizarConsulta}
        ></FilterModal>)
      }
  </>
 );
};

export default InformePromEspera;
